export const tableHelpers = {
    data() {
        return {
            tableColumns: [
                {
                    title: "Nombre",
                    type: 'text',
                    key: 'name',
                },
                {
                    title: "Responsable",
                    type: 'text',
                    key: 'legal_representative',
                },
                {
                    title: "Estado",
                    type: "custom-html",
                    key: "is_active",
                    modifier: (item) => {
                        let className = "";
                        let status = "";
                        if (item) {
                            className = "success";
                            status = "Activo";
                        } else {
                            className = "danger";
                            status = "Inactivo";
                        }
                        return `<span class="badge badge-sm badge-pill badge-${className}">${status}</span>`;
                    },
                },
            ],
            actionObj: {
                title: 'Acción',
                type: 'action',
            }
        }
    },
}